import gql from 'graphql-tag';

const query = gql`
  query fetchAmEventsAttendeeExportAvailable{
    viewer {
      id
      heAccount {
        id
        amEventsAttendeeExportAvailable
      }
    }
  }
`;

export default query;
